
<template>
    <div style="overflow-y: hidden;">
        <!-- 顶部工具栏 -->
        <div class="toolbar">
            <el-form :inline="true" :model="searchForm" style="margin-bottom: 10px;">
                <el-form-item label="角色搜索：">
                    <el-input 
                        v-model="searchForm.roleName" 
                        placeholder="请输入角色名称" 
                        clearable 
                        style="width: 200px;"
                        @input="filterRoles">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="searchRoles" v-show="isShowBtn('authorityManage','权限管理','Search')">搜索</el-button>
                    <el-button icon="Refresh" @click="resetSearch">重置</el-button>
                    <el-button type="success" icon="Plus" @click="showCreateRole" v-show="isShowBtn('authorityManage','权限管理','Create')">新增角色</el-button>
                    <el-button type="primary" icon="Edit" @click="showEditRole" :disabled="!roleObj.id" v-show="isShowBtn('authorityManage','权限管理','Update')">编辑角色</el-button>
                    <el-button type="danger" icon="Delete" @click="deleteRole" :disabled="!roleObj.id" v-show="isShowBtn('authorityManage','权限管理','Delete')">删除角色</el-button>
                    <el-button type="warning" icon="CopyDocument" @click="showCopyAuth" v-show="isShowBtn('authorityManage','权限管理','Update')">权限复制</el-button>
                    <el-button type="info" icon="Plus" @click="showBatchAuth" v-show="isShowBtn('authorityManage','权限管理','Create')">批量授权</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-form>
        <div class="auth-outer">
            <div>
                <div class="auth-item" style="width: 320px;height: calc(100vh - 200px)">
                    <div class="auth-item-header">
                        <el-tag size="large" style="font-size: 13px">当前选择:{{ roleObj.name ? roleObj.name : "无" }}</el-tag>
                        <div>
                            <el-button type="primary" size="small" @click="submitPermisson" :disabled="!roleObj.id">保存</el-button>
                            <el-button type="info" size="small" @click="resetPermissions" :disabled="!roleObj.id">重置</el-button>
                        </div>
                    </div>
                    <el-scrollbar>
                        <div style="margin: 10px 0px 50px 0px;" v-loading="loadingPage">
                            <el-form-item>
                                <el-tree
                                    class="filter-tree"
                                    :data="data"
                                    :highlight-current="true"
                                    :props="{ label: 'name' }"
                                    default-expand-all
                                    :filter-node-method="filterNode"
                                    @node-click="nodeClick"
                                    node-key="node_id"
                                    ref="tree"
                                    empty-text="暂无角色数据"/>
                            </el-form-item>
                        </div>
                    </el-scrollbar>
                </div>
                <!-- <div class="auth-item" style="height: calc(100vh - 430px);">
                    <el-scrollbar>
                        <div class="auth-title">
                            数据授权：
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="授权用户可操作的数据范围"
                                placement="right">
                                <el-icon><question-filled /></el-icon>
                            </el-tooltip>
                        </div>
                        <el-select
                                size="large"
                                v-show="roleObj.name"
                                v-model="roleObj.data_range"
                                @change="dataScopeSelectChange" style="width: 90%;margin: 10px auto;display: block;">
                            <el-option
                                v-for="item in dataScopeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <div style="margin-bottom: 50px" v-show="roleObj.data_range === 4">
                            <el-form-item>
                                <el-tree
                                class="tree-border"
                                :data="deptOptions"
                                show-checkbox
                                default-expand-all
                                :default-checked-keys="deptCheckedKeys"
                                ref="dept"
                                node-key="id"
                                size="small"
                                :check-strictly="true"
                                :props="{ label: 'name',children: 'children', disabled: 'disabled'}"/>
                            </el-form-item>
                        </div>
                    </el-scrollbar>
                </div> -->
            </div>
            <div class="auth-item" style="height: calc(100vh - 200px);">
                <div class="auth-title">
                    菜单授权：
                    <el-tooltip
                        effect="dark"
                        content="授权用户在菜单中可操作的范围"
                        placement="right">
                        <el-icon><question-filled /></el-icon>
                    </el-tooltip>
                    <div class="auth-actions">
                        <el-button size="small" type="success" @click="expandAll" :disabled="!roleObj.id">全部展开</el-button>
                        <el-button size="small" type="info" @click="collapseAll" :disabled="!roleObj.id">全部收起</el-button>
                        <el-button size="small" type="primary" @click="checkAll" :disabled="!roleObj.id">全选</el-button>
                        <el-button size="small" type="warning" @click="uncheckAll" :disabled="!roleObj.id">取消全选</el-button>
                    </div>
                </div>
                <el-scrollbar>
                    <div style="margin: 20px 20px 90px 20px;" >
                        <el-form-item>
                            <el-tree
                                class="lymenupermisson"
                                ref="menuTree"
                                :data="menuOptions"
                                node-key="id"
                                default-expand-all
                                show-checkbox
                                :expand-on-click-node="false"
                                :default-checked-keys="menuCheckedKeys"
                                :check-on-click-node="false"
                                :check-strictly="true"
                                empty-text="请先选择角色"
                                @check-change="handleCheckClick">
                                 <template v-slot="{ node, data }">
                                      <span class="custom-tree-node" >
                                        <div class="menu-data">
                                          <div :style="{width:((4-node.level)*18+118)+'px'}">{{ data.name }}</div>
                                          <div>
                                            <el-checkbox
                                                v-for="(item, index) in data.menuPermission"
                                                :key="index"
                                                v-model="item.checked">{{ item.name }}</el-checkbox>
                                          </div>
                                        </div>
                                      </span>
                                 </template>
                            </el-tree>
                        </el-form-item>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        </el-form>

        <!-- 批量授权对话框 -->
        <el-dialog
            v-model="batchAuthVisible"
            title="批量权限授权"
            width="600px"
            :close-on-click-modal="false">
            <el-form :model="batchAuthForm" label-width="100px">
                <el-form-item label="选择角色：">
                    <el-select 
                        v-model="batchAuthForm.roleIds" 
                        multiple 
                        placeholder="请选择需要授权的角色"
                        style="width: 100%">
                        <el-option
                            v-for="role in data"
                            :key="role.id"
                            :label="role.name"
                            :value="role.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限模板：">
                    <el-select 
                        v-model="batchAuthForm.templateRoleId" 
                        placeholder="选择权限模板角色"
                        style="width: 100%">
                        <el-option
                            v-for="role in data"
                            :key="role.id"
                            :label="role.name + '（作为模板）'"
                            :value="role.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="batchAuthVisible = false">取消</el-button>
                <el-button type="primary" @click="executeBatchAuth" :loading="batchAuthLoading">确定授权</el-button>
            </template>
        </el-dialog>

        <!-- 权限复制对话框 -->
        <el-dialog
            v-model="copyAuthVisible"
            title="权限复制"
            width="500px"
            :close-on-click-modal="false">
            <el-form :model="copyAuthForm" label-width="100px">
                <el-form-item label="源角色：">
                    <el-select 
                        v-model="copyAuthForm.sourceRoleId" 
                        placeholder="选择源角色"
                        style="width: 100%">
                        <el-option
                            v-for="role in data"
                            :key="role.id"
                            :label="role.name"
                            :value="role.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标角色：">
                    <el-select 
                        v-model="copyAuthForm.targetRoleId" 
                        placeholder="选择目标角色"
                        style="width: 100%">
                        <el-option
                            v-for="role in data"
                            :key="role.id"
                            :label="role.name"
                            :value="role.id"
                            :disabled="role.id === copyAuthForm.sourceRoleId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="copyAuthForm.overwrite">覆盖目标角色现有权限</el-checkbox>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="copyAuthVisible = false">取消</el-button>
                <el-button type="primary" @click="executeCopyAuth" :loading="copyAuthLoading">确定复制</el-button>
            </template>
        </el-dialog>

        <!-- 创建/编辑角色对话框 -->
        <el-dialog
            v-model="roleFormVisible"
            :title="roleFormMode === 'create' ? '新增角色' : '编辑角色'"
            width="600px"
            :close-on-click-modal="false">
            <el-form :model="roleForm" :rules="roleFormRules" ref="roleFormRef" label-width="100px">
                <el-form-item label="角色名称：" prop="name">
                    <el-input 
                        v-model="roleForm.name" 
                        placeholder="请输入角色名称"
                        maxlength="50"
                        show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="角色标识：" prop="key">
                    <el-input 
                        v-model="roleForm.key" 
                        placeholder="请输入角色标识（英文）"
                        maxlength="50"
                        show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="角色描述：">
                    <el-input 
                        v-model="roleForm.description" 
                        type="textarea"
                        :rows="4"
                        placeholder="请输入角色描述"
                        maxlength="200"
                        show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="角色状态：">
                    <el-radio-group v-model="roleForm.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序：">
                    <el-input-number 
                        v-model="roleForm.sort" 
                        :min="0" 
                        :max="9999"
                        placeholder="数字越小排序越靠前">
                    </el-input-number>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="roleFormVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRoleForm" :loading="roleFormLoading">
                    {{ roleFormMode === 'create' ? '创建' : '更新' }}
                </el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {apiSystemRole,apiSystemRoleIdToMenuid,apiPermissionSave,apiSystemRoleAdd,apiSystemRoleEdit,apiSystemRoleDelete} from '@/api/api'
    import XEUtils from 'xe-utils'
    export default {
        name: "authorityManage",
        data() {
            return {
                filterText: '',
                activeName:'',
                menuOptions: [],
                menuCheckedKeys: [], // 菜单默认选中的节点
                deptOptions:[],
                deptCheckedKeys:[],
                data: [],
                originalData: [], // 保存原始角色数据用于搜索
                roleObj: {
                    name: null,
                    data_range: null
                },
                loadingPage:false,
                optionsData:[],
                optionsDataAll:[],
                // 搜索表单
                searchForm: {
                    roleName: ''
                },
                // 批量授权相关
                batchAuthVisible: false,
                batchAuthLoading: false,
                batchAuthForm: {
                    roleIds: [],
                    templateRoleId: null
                },
                // 权限复制相关
                copyAuthVisible: false,
                copyAuthLoading: false,
                copyAuthForm: {
                    sourceRoleId: null,
                    targetRoleId: null,
                    overwrite: true
                },
                // 角色表单相关
                roleFormVisible: false,
                roleFormLoading: false,
                roleFormMode: 'create', // 'create' 或 'edit'
                roleForm: {
                    id: null,
                    name: '',
                    key: '',
                    description: '',
                    status: 1,
                    sort: 0
                },
                roleFormRules: {
                    name: [
                        { required: true, message: '请输入角色名称', trigger: 'blur' },
                        { min: 2, max: 50, message: '角色名称长度在 2 到 50 个字符', trigger: 'blur' }
                    ],
                    key: [
                        { required: true, message: '请输入角色标识', trigger: 'blur' },
                        { min: 2, max: 50, message: '角色标识长度在 2 到 50 个字符', trigger: 'blur' },
                        { pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: '角色标识必须以字母开头，只能包含字母、数字和下划线', trigger: 'blur' }
                    ]
                },
                dataScopeOptions: [
                    {
                        value: 0,
                        label: '仅本人数据权限'
                    },
                    {
                        value: 1,
                        label: '本部门数据权限'
                    },
                    {
                        value: 2,
                        label: '本部门及以下数据权限'
                    },
                    {
                        value: 3,
                        label: '全部数据权限'
                    },
                    {
                        value: 4,
                        label: '自定数据权限'
                    }
                ],
            }
        },
        created() {
            this.pageRequest()
        },
        methods:{
            // 获取角色
            pageRequest (query) {
                this.loadingPage = true
                return apiSystemRole(query).then((res) => {
                    this.loadingPage = false
                    if(res.code === 2000) {
                        this.originalData = res.data.data || []
                        this.data = [...this.originalData]
                        this.data.map((value, index) => {
                            value.node_id = index
                        })
                        this.$nextTick().then(() => {
                            this.initNode()
                        })
                    } else {
                        this.$message.warning(res.msg || '获取角色列表失败')
                    }
                }).catch(err => {
                    this.loadingPage = false
                    this.$message.error('获取角色列表失败')
                    console.error(err)
                })
            },
            initNode () {
                if (this.$route.query.id && this.$refs.tree) {
                    this.data.map((value) => {
                        if (this.$route.query.id === value.id) {
                            this.node_id = value.node_id
                        }
                    })
                    const node = this.$refs.tree.getNode(this.node_id)
                    this.$refs.tree.setCurrentKey(node)
                    this.nodeClick(node.data, node)
                }
            },

            // 提交修改
            submitPermisson() {
                this.roleObj.menu = this.getMenuAllCheckedKeys() // 获取选中的菜单
                // this.roleObj.dept = this.getDeptAllCheckedKeys() // 获取选中的部门
                const menuData = XEUtils.toTreeArray(this.menuOptions)
                const permissionData = []
                menuData.forEach((x) => {
                    const checkedPermission = x.menuPermission.filter((f) => {
                        return f.checked
                    })

                    if (checkedPermission.length > 0) {
                        for (const item of checkedPermission) {
                            permissionData.push(item.id)
                        }
                    }
                })
                this.roleObj.permission = permissionData

                this.updateRequest(this.roleObj)
            },
            updateRequest (row) {
                apiPermissionSave(row).then(res=>{
                    if(res.code ==2000) {
                        this.$message.success(res.msg)
                        this.pageRequest()
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            },
            // 获取菜单数据
            getMenuData (data) {
                apiSystemRoleIdToMenuid(data.id).then((res) => {
                    res.data.data.forEach((x) => {
                        // 根据当前角色的permission,对menuPermisson进行勾选处理
                        x.menuPermission.forEach((a) => {
                            // 确保数据类型一致性，将权限ID转换为字符串进行比较
                            const permissionIds = data.permission ? data.permission.map(id => String(id)) : []
                            const menuPermissionId = String(a.id)
                            
                            if (permissionIds.indexOf(menuPermissionId) > -1) {
                                a.checked = true
                            } else {
                                a.checked = false
                            }
                        })
                    })
                    // 将菜单列表转换为树形列表
                    this.menuOptions = XEUtils.toArrayTree(res.data.data, { parentKey: 'parent' })
                })
            },

            // 所有勾选菜单节点数据
            getMenuAllCheckedKeys () {
                // 目前被选中的菜单节点
                const checkedKeys = this.$refs.menuTree.getCheckedKeys()
                // 半选中的菜单节点
                const halfCheckedKeys = this.$refs.menuTree.getHalfCheckedKeys()
                checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys)
                return checkedKeys
            },
            // 所有自定义权限时,勾选的部门节点数据
            // getDeptAllCheckedKeys () {
            //     // 目前被选中的部门节点
            //     const checkedKeys = this.$refs.dept.getCheckedKeys()
            //     // 半选中的部门节点
            //     const halfCheckedKeys = this.$refs.dept.getHalfCheckedKeys()
            //     checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys)
            //     return checkedKeys
            // },
            filterNode (value, data) {
                if (!value) return true
                return data.label.indexOf(value) !== -1
            },
            // 角色树被点击
            nodeClick (data, node, self) {
                this.roleObj = data
                // this.getDeptData()
                this.getMenuData(data)
                this.menuCheckedKeys = data.menu // 加载已勾选的菜单
                // this.deptCheckedKeys = data.dept
            },
            /** 选择角色权限范围触发 */
            dataScopeSelectChange (value) {
                if (value !== 4) {
                    // this.$refs.dept.setCheckedKeys([]);
                }
            },
            /**
             * 菜单树点击,全选权限部分数据
             * @param data
             */
            handleCheckClick(data, checked) {
              const {
                menuPermission,
                children
              } = data
              for (let item of menuPermission) {
                // this.$set(item, 'checked', checked)
                  item.checked=checked
              }
              if (children) {
                for (let item of children) {
                  this.$refs.menuTree.setChecked(item.id, checked)
                }
              }
            },

            // 搜索功能
            filterRoles() {
                if (!this.searchForm.roleName.trim()) {
                    this.data = [...this.originalData]
                } else {
                    this.data = this.originalData.filter(role => 
                        role.name.toLowerCase().includes(this.searchForm.roleName.toLowerCase())
                    )
                }
                // 重新设置node_id
                this.data.map((value, index) => {
                    value.node_id = index
                })
            },

            searchRoles() {
                this.filterRoles()
                this.$message.success(`搜索到 ${this.data.length} 个角色`)
            },

            resetSearch() {
                this.searchForm.roleName = ''
                this.data = [...this.originalData]
                this.data.map((value, index) => {
                    value.node_id = index
                })
            },

            // 重置权限
            resetPermissions() {
                if (!this.roleObj.id) return
                this.$confirm('确定要重置当前角色的权限吗？这将清除所有权限设置。', '确认重置', {
                    type: 'warning'
                }).then(() => {
                    // 清除菜单树选中状态
                    this.$refs.menuTree.setCheckedKeys([])
                    // 清除权限复选框
                    this.menuOptions.forEach(menu => {
                        if (menu.menuPermission) {
                            menu.menuPermission.forEach(perm => {
                                perm.checked = false
                            })
                        }
                    })
                    this.$message.success('权限已重置')
                }).catch(() => {})
            },

            // 展开所有菜单
            expandAll() {
                if (this.$refs.menuTree) {
                    const allKeys = []
                    const getAllKeys = (nodes) => {
                        nodes.forEach(node => {
                            allKeys.push(node.id)
                            if (node.children && node.children.length > 0) {
                                getAllKeys(node.children)
                            }
                        })
                    }
                    getAllKeys(this.menuOptions)
                    
                    // 手动展开所有节点
                    allKeys.forEach(key => {
                        this.$refs.menuTree.store.nodesMap[key] && (this.$refs.menuTree.store.nodesMap[key].expanded = true)
                    })
                }
            },

            // 收起所有菜单
            collapseAll() {
                if (this.$refs.menuTree) {
                    const allKeys = []
                    const getAllKeys = (nodes) => {
                        nodes.forEach(node => {
                            allKeys.push(node.id)
                            if (node.children && node.children.length > 0) {
                                getAllKeys(node.children)
                            }
                        })
                    }
                    getAllKeys(this.menuOptions)
                    
                    // 手动收起所有节点
                    allKeys.forEach(key => {
                        this.$refs.menuTree.store.nodesMap[key] && (this.$refs.menuTree.store.nodesMap[key].expanded = false)
                    })
                }
            },

            // 全选菜单
            checkAll() {
                if (this.$refs.menuTree) {
                    const allKeys = []
                    const getAllKeys = (nodes) => {
                        nodes.forEach(node => {
                            allKeys.push(node.id)
                            if (node.children && node.children.length > 0) {
                                getAllKeys(node.children)
                            }
                        })
                    }
                    getAllKeys(this.menuOptions)
                    this.$refs.menuTree.setCheckedKeys(allKeys)
                    
                    // 同时选中所有权限
                    this.menuOptions.forEach(menu => {
                        if (menu.menuPermission) {
                            menu.menuPermission.forEach(perm => {
                                perm.checked = true
                            })
                        }
                        if (menu.children) {
                            const checkChildren = (children) => {
                                children.forEach(child => {
                                    if (child.menuPermission) {
                                        child.menuPermission.forEach(perm => {
                                            perm.checked = true
                                        })
                                    }
                                    if (child.children) {
                                        checkChildren(child.children)
                                    }
                                })
                            }
                            checkChildren(menu.children)
                        }
                    })
                }
            },

            // 取消全选
            uncheckAll() {
                if (this.$refs.menuTree) {
                    this.$refs.menuTree.setCheckedKeys([])
                    // 取消所有权限选择
                    this.menuOptions.forEach(menu => {
                        if (menu.menuPermission) {
                            menu.menuPermission.forEach(perm => {
                                perm.checked = false
                            })
                        }
                        if (menu.children) {
                            const uncheckChildren = (children) => {
                                children.forEach(child => {
                                    if (child.menuPermission) {
                                        child.menuPermission.forEach(perm => {
                                            perm.checked = false
                                        })
                                    }
                                    if (child.children) {
                                        uncheckChildren(child.children)
                                    }
                                })
                            }
                            uncheckChildren(menu.children)
                        }
                    })
                }
            },

            // 显示批量授权对话框
            showBatchAuth() {
                this.batchAuthForm = {
                    roleIds: [],
                    templateRoleId: null
                }
                this.batchAuthVisible = true
            },

            // 执行批量授权
            executeBatchAuth() {
                if (!this.batchAuthForm.templateRoleId) {
                    this.$message.warning('请选择权限模板角色')
                    return
                }
                if (this.batchAuthForm.roleIds.length === 0) {
                    this.$message.warning('请选择需要授权的角色')
                    return
                }

                this.batchAuthLoading = true
                
                // 获取模板角色的权限
                const templateRole = this.originalData.find(role => role.id === this.batchAuthForm.templateRoleId)
                if (!templateRole) {
                    this.$message.error('找不到模板角色')
                    this.batchAuthLoading = false
                    return
                }

                // 获取模板角色的菜单权限
                apiSystemRoleIdToMenuid(templateRole.id).then((res) => {
                    if (res.code === 2000) {
                        const templatePermissions = []
                        const templateMenus = []
                        
                        res.data.data.forEach((menu) => {
                            templateMenus.push(menu.id)
                            if (menu.menuPermission && templateRole.permission) {
                                // 确保数据类型一致性
                                const templatePermissionIds = templateRole.permission.map(id => String(id))
                                menu.menuPermission.forEach((perm) => {
                                    if (templatePermissionIds.indexOf(String(perm.id)) > -1) {
                                        templatePermissions.push(perm.id)
                                    }
                                })
                            }
                        })

                        // 批量应用权限
                        const promises = this.batchAuthForm.roleIds.map(roleId => {
                            return apiPermissionSave({
                                id: roleId,
                                permission: templatePermissions,
                                menu: templateMenus
                            })
                        })

                        Promise.all(promises).then(results => {
                            const successCount = results.filter(res => res.code === 2000).length
                            if (successCount === results.length) {
                                this.$message.success(`成功为 ${successCount} 个角色授权`)
                                this.pageRequest()
                            } else {
                                this.$message.warning(`${successCount}/${results.length} 个角色授权成功`)
                            }
                            this.batchAuthVisible = false
                            this.batchAuthLoading = false
                        }).catch(err => {
                            this.$message.error('批量授权失败')
                            this.batchAuthLoading = false
                            console.error(err)
                        })
                    } else {
                        this.$message.error('获取模板权限失败')
                        this.batchAuthLoading = false
                    }
                }).catch(err => {
                    this.$message.error('获取模板权限失败')
                    this.batchAuthLoading = false
                    console.error(err)
                })
            },

            // 显示权限复制对话框
            showCopyAuth() {
                this.copyAuthForm = {
                    sourceRoleId: null,
                    targetRoleId: null,
                    overwrite: true
                }
                this.copyAuthVisible = true
            },

            // 执行权限复制
            executeCopyAuth() {
                if (!this.copyAuthForm.sourceRoleId) {
                    this.$message.warning('请选择源角色')
                    return
                }
                if (!this.copyAuthForm.targetRoleId) {
                    this.$message.warning('请选择目标角色')
                    return
                }
                if (this.copyAuthForm.sourceRoleId === this.copyAuthForm.targetRoleId) {
                    this.$message.warning('源角色和目标角色不能相同')
                    return
                }

                this.copyAuthLoading = true

                // 获取源角色权限
                const sourceRole = this.originalData.find(role => role.id === this.copyAuthForm.sourceRoleId)
                apiSystemRoleIdToMenuid(sourceRole.id).then((res) => {
                    if (res.code === 2000) {
                        const sourcePermissions = []
                        const sourceMenus = []
                        
                        res.data.data.forEach((menu) => {
                            sourceMenus.push(menu.id)
                            if (menu.menuPermission && sourceRole.permission) {
                                // 确保数据类型一致性
                                const sourcePermissionIds = sourceRole.permission.map(id => String(id))
                                menu.menuPermission.forEach((perm) => {
                                    if (sourcePermissionIds.indexOf(String(perm.id)) > -1) {
                                        sourcePermissions.push(perm.id)
                                    }
                                })
                            }
                        })

                        // 应用到目标角色
                        apiPermissionSave({
                            id: this.copyAuthForm.targetRoleId,
                            permission: sourcePermissions,
                            menu: sourceMenus
                        }).then(copyRes => {
                            if (copyRes.code === 2000) {
                                this.$message.success('权限复制成功')
                                this.pageRequest()
                                this.copyAuthVisible = false
                            } else {
                                this.$message.error(copyRes.msg || '权限复制失败')
                            }
                            this.copyAuthLoading = false
                        }).catch(err => {
                            this.$message.error('权限复制失败')
                            this.copyAuthLoading = false
                            console.error(err)
                        })
                    } else {
                        this.$message.error('获取源角色权限失败')
                        this.copyAuthLoading = false
                    }
                }).catch(err => {
                    this.$message.error('获取源角色权限失败')
                    this.copyAuthLoading = false
                    console.error(err)
                })
            },

            // 显示创建角色对话框
            showCreateRole() {
                this.roleFormMode = 'create'
                this.roleForm = {
                    id: null,
                    name: '',
                    key: '',
                    description: '',
                    status: 1,
                    sort: 0
                }
                this.roleFormVisible = true
                this.$nextTick(() => {
                    this.$refs.roleFormRef?.clearValidate()
                })
            },

            // 显示编辑角色对话框
            showEditRole() {
                if (!this.roleObj.id) {
                    this.$message.warning('请先选择要编辑的角色')
                    return
                }
                this.roleFormMode = 'edit'
                this.roleForm = {
                    id: this.roleObj.id,
                    name: this.roleObj.name || '',
                    key: this.roleObj.key || '',
                    description: this.roleObj.description || '',
                    status: this.roleObj.status !== undefined ? this.roleObj.status : 1,
                    sort: this.roleObj.sort || 0
                }
                this.roleFormVisible = true
                this.$nextTick(() => {
                    this.$refs.roleFormRef?.clearValidate()
                })
            },

            // 提交角色表单
            submitRoleForm() {
                this.$refs.roleFormRef.validate((valid) => {
                    if (valid) {
                        this.roleFormLoading = true
                        
                        if (this.roleFormMode === 'create') {
                            // 创建角色
                            this.createRole()
                        } else {
                            // 更新角色
                            this.updateRole()
                        }
                    }
                })
            },

            // 创建角色
            createRole() {
                apiSystemRoleAdd(this.roleForm).then((res) => {
                    if (res.code === 2000) {
                        this.$message.success('角色创建成功')
                        this.roleFormVisible = false
                        this.pageRequest()
                    } else {
                        this.$message.error(res.msg || '角色创建失败')
                    }
                    this.roleFormLoading = false
                }).catch(err => {
                    this.$message.error('角色创建失败')
                    this.roleFormLoading = false
                    console.error(err)
                })
            },

            // 更新角色
            updateRole() {
                apiSystemRoleEdit({ ...this.roleForm, id: this.roleForm.id }).then((res) => {
                    if (res.code === 2000) {
                        this.$message.success('角色更新成功')
                        this.roleFormVisible = false
                        this.pageRequest()
                        // 如果更新的是当前选中的角色，需要更新当前选中状态
                        if (this.roleObj.id === this.roleForm.id) {
                            this.roleObj = { ...this.roleObj, ...this.roleForm }
                        }
                    } else {
                        this.$message.error(res.msg || '角色更新失败')
                    }
                    this.roleFormLoading = false
                }).catch(err => {
                    this.$message.error('角色更新失败')
                    this.roleFormLoading = false
                    console.error(err)
                })
            },

            // 删除角色
            deleteRole() {
                if (!this.roleObj.id) {
                    this.$message.warning('请先选择要删除的角色')
                    return
                }

                this.$confirm(`确定要删除角色"${this.roleObj.name}"吗？删除后不可恢复。`, '确认删除', {
                    type: 'warning',
                    confirmButtonText: '确定删除',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'el-button--danger'
                }).then(() => {
                    apiSystemRoleDelete({ id: this.roleObj.id }).then((res) => {
                        if (res.code === 2000) {
                            this.$message.success('角色删除成功')
                            // 清空当前选中的角色
                            this.roleObj = { name: null, data_range: null }
                            this.menuOptions = []
                            this.menuCheckedKeys = []
                            this.pageRequest()
                        } else {
                            this.$message.error(res.msg || '角色删除失败')
                        }
                    }).catch(err => {
                        this.$message.error('角色删除失败')
                        console.error(err)
                    })
                }).catch(() => {
                    // 用户取消删除
                })
            },

        },
        watch: {
            filterText (val) {
                this.$refs.tree.filter(val)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .toolbar {
        background: #FFFFFF;
        padding: 16px 20px;
        margin-bottom: 16px;
        border-radius: 12px;
        border: 1px solid #F2F2F7;
        box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    }

    .el-tree { width: 100%; }
    
    .auth-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        font-weight: 500;
        color: #6E6E73;
        background: #FAFAFA;
        padding: 12px 16px;
        
        .auth-actions { display: flex; gap: 8px; }
    }
    
    .custom-tree-node {
        .menu-data { display: flex; margin: 10px 0; }
    }
    
    .auth-outer {
        display: flex;
        column-gap: 12px;
        .auth-item {
            flex: 1;
            background: #FFFFFF;
            border-radius: 12px;
            border: 1px solid #E5E5EA;
            box-shadow: 0 1px 3px rgba(0,0,0,0.06);
            overflow: hidden;
            
            .auth-item-header {
                background: #FAFAFA;
                padding: 12px 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #E5E5EA;
                
                .el-tag { margin-right: 10px; }
            }
        }
    }
    
    .filter-tree {
        ::v-deep(.el-tree-node__content) {
            height: 40px;
            &:hover { background: #F5F8FF; }
        }
        ::v-deep(.el-tree-node.is-current > .el-tree-node__content) {
            background: #EBF2FD;
            color: #1D6FE8;
        }
    }
    
    .lymenupermisson {
        ::v-deep(.el-tree-node__content) {
            height: auto;
            min-height: 30px;
            padding: 5px 0;
        }
        ::v-deep(.el-checkbox) {
            margin-right: 8px;
            .el-checkbox__label { font-size: 12px; }
        }
    }

    @media (max-width: 1200px) {
        .auth-outer {
            flex-direction: column;
            .auth-item { height: auto !important; min-height: 300px; }
        }
    }
</style>
